import logger from '@elab/core/utils/logger';
import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const getBaseUri = () => apiUtils.getBaseUri();
const getApiService = () => `${getBaseUri()}/users/current`;
const getUserApiService = abbr => `${getBaseUri()}/users/${abbr}`;

export const getSelectedLanguageContent = async ({ langUrl, data }) => {
    const response = await fetch(langUrl, {
        body: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            enctype: 'multipart/form-data',
        },
    });

    if (!response.ok) {
        logger.warn(`Language select network response was not ok (${response.status})`);
    }

    return response.url;
};

export const setCustomerLanguage = async isoCode => {
    const response = await HTTPClient().patchJson(getApiService(), {
        language: {
            isoCode,
        },
    });

    if (!response.ok) {
        throw new Error(`User's language change network response was not ok (${response.status})`);
    }
};

export const getConfiguration = async keyName => {
    const uri = `${getBaseUri()}/configurations?key=${keyName}`;

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load order (${response.status})`);
    }
    return await response.json();
};

export const getComponentsByUid = async path => {
    const response = await HTTPClient().get(path);

    if (!response.ok) {
        throw new Error(`Unable to load component(${response.status})`);
    }

    return response.text();
};

export const getComponentsByIds = async (ids, userId) => {
    const userAbbr = userId ? 'current' : 'anonymous';`${getBaseUri()}/users/anonymous/cms/components/?componentIds=${ids}&pageSize=100`;
    const uri = `${getUserApiService(userAbbr)}/cms/components/?componentIds=${ids}&pageSize=100`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load cms components (${response.status})`);
    }
    return await response.json();
};
